// test2242
(2242 && 0);
